
import { useEffect } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import DrivingHeroEn from './components/DrivingHeroEn';
import ServicesSectionEn from './components/ServicesSectionEn';
import PricingSectionEn from './components/PricingSectionEn';
import BookingFormSectionEn from './components/BookingFormSectionEn';
import StickyWhatsAppButton from '../../components/feature/StickyWhatsAppButton';

export default function DrivingAssistantEnPage() {
  useEffect(() => {
    document.title = 'Tokyo Driving Assistance Service | Rental Car Support | Tokyo Minpaku';

    const setMeta = (name: string, content: string, isProperty = false) => {
      const attr = isProperty ? 'property' : 'name';
      let el = document.querySelector(`meta[${attr}="${name}"]`);
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };

    setMeta('description', 'Professional driving assistance for your rental car in Tokyo. Airport support, navigation help, and local guidance. Not a transportation business - we support your self-arranged rental car.');
    setMeta('keywords', 'driving assistant Tokyo, rental car support Tokyo, Tokyo sightseeing, airport assistance, navigation support, local guide Tokyo, inbound tourism, foreign visitors Japan');

    setMeta('og:title', 'Tokyo Driving Assistance Service | Rental Car Support | Tokyo Minpaku', true);
    setMeta('og:description', 'Professional driving assistance for your rental car in Tokyo. Airport support, navigation help, and local guidance. Not a transportation business.', true);
    setMeta('og:type', 'website', true);
    setMeta('og:url', 'https://tokyominpaku.com/driving-assistant-en', true);

    setMeta('twitter:card', 'summary_large_image');
    setMeta('twitter:title', 'Tokyo Driving Assistance Service | Rental Car Support | Tokyo Minpaku');
    setMeta('twitter:description', 'Professional driving assistance for your rental car in Tokyo. Airport support, navigation help, and local guidance.');
  }, []);

  return (
    <div className="min-h-screen bg-zinc-900">
      <Navbar />
      <DrivingHeroEn />
      <ServicesSectionEn />
      <PricingSectionEn />
      <BookingFormSectionEn />
      <Footer />
      <StickyWhatsAppButton
        phoneNumber="819092895522"
        message="Hi! I'd like to inquire about your Driving Assistant Service.%0A%0A[Preferred Date]%0A[Duration]%0A[Number of Passengers]%0A%0AThank you!"
        label="Book via WhatsApp"
      />
    </div>
  );
}